import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {ContactReducerType, ISaveContact, ISearchContact} from "./Types";
import Contact from "../../Models/Contact";

const initialState: ContactReducerType = {
  contacts: [],
  contactsByClient: [],
}

const ContactsSlice = createSlice({
  name: "Contact",
  initialState,
  reducers: {
    getContacts(state, { payload }: PayloadAction<ISearchContact>) {},
    setContacts(state: any, { payload }: PayloadAction<Contact[]>) {
      state.contacts = payload
    },
    saveContact(state: any, { payload }: PayloadAction<ISaveContact>) {},
    deleteContact(state: any, { payload }: PayloadAction<Contact>) {},
  }
});

export const ContactsActions = ContactsSlice.actions;

export default ContactsSlice.reducer
